(function () {
  function initWsTabs() {
    const tabsContainers = document.querySelectorAll('.wp-block-ws-library-ws-tabs');
    // console.log(`Trouvé ${tabsContainers.length} conteneur(s) d’onglets`);

    tabsContainers.forEach((container, containerIndex) => {
      // console.log(`\n🔧 Initialisation du container #${containerIndex + 1}`);

      const titlesList = container.querySelector('.tabs-titles');
      const titleItems = titlesList
        ? Array.from(titlesList.querySelectorAll('li.tab-title'))
        : [];

      const contentWrapper = container.querySelector('.tabs-list');
      // console.log(contentWrapper);
      const panels = contentWrapper
        ? Array.from(contentWrapper.querySelectorAll('.wp-block-ws-library-ws-tab'))
        : [];
      // console.log(panels);

      // console.log(`• ${titleItems.length} titre(s) trouvé(s)`);
      // console.log(`• ${panels.length} panel(s) trouvé(s)`);

      if (!titlesList || titleItems.length === 0 || panels.length === 0) {
        console.warn('⛔ Structure manquante dans le container, bloc ignoré.');
        return;
      }

      function deactivateAll() {
        titleItems.forEach((li) => {
          li.classList.remove('is-active');
        });
        panels.forEach((panel) => {
          panel.classList.remove('is-active');
          panel.style.display = 'none';
        });
      }

      let initialIndex = 0;
      const activeTitle = titleItems.findIndex((li) =>
        li.classList.contains('is-active')
      );
      if (activeTitle >= 0 && activeTitle < titleItems.length) {
        initialIndex = activeTitle;
      }

      // console.log(`• Onglet actif initial : ${initialIndex}`);

      deactivateAll();
      titleItems[initialIndex].classList.add('is-active');
      const panelToShow = panels[initialIndex];
      if (panelToShow) {
        panelToShow.classList.add('is-active');
        panelToShow.style.display = '';
        // console.log(`✅ Panel #${initialIndex} affiché`);
      } else {
        console.warn(`❌ Aucun panel trouvé pour l’index initial ${initialIndex}`);
      }

      titleItems.forEach((li, i) => {
        li.addEventListener('click', () => {
          const newIndex = parseInt(li.getAttribute('data-tab-index'), 10);
          // console.log(`🖱️ Onglet cliqué : index=${newIndex} (texte="${li.textContent}")`);

          if (isNaN(newIndex)) {
            console.warn('❌ data-tab-index invalide');
            return;
          }

          deactivateAll();
          li.classList.add('is-active');

          const newPanel = panels[newIndex];
          if (newPanel) {
            newPanel.classList.add('is-active');
            newPanel.style.display = '';
            // console.log(`✅ Panel #${newIndex} affiché`);
          } else {
            console.warn(`❌ Aucun panel trouvé pour l’index ${newIndex}`);
          }
        });
      });
    });
  }
  
  function isEditor() {
    return typeof wp !== 'undefined' && !!document.body.classList.contains('block-editor-page');
  }

  function observeDomChanges() {
    const observer = new MutationObserver(() => {
      initWsTabs();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initWsTabs();
      if (isEditor()) {
        observeDomChanges();
      }
    });
  } else {
    initWsTabs();
    if (isEditor()) {
      observeDomChanges();
    }
  }
  
})();
